import {
  METHODS,
  defaultHeaders,
  RESPONSE_CODES,
  API_ENDPOINT,
  FetchResponseType,
} from "../../constants";
import { getSessionToken } from "../auth/AuthServices";
import { ProductIngredientsResponse } from "../ResponseModel";

const enum RESOURCES {
  products = "products",
  ingredients = "ingredients",
}

const packedHeaders = () => {
  return { ...defaultHeaders, "FDS-Auth": getSessionToken() };
};

export const AddIngredientToProduct = async () => {};
export const RemoveIngredientToProduct = async () => {};

/**
 * Obtiene los ingredientes de un producto a través de su id
 */
export const GetProductIngredients = async (product_id: string) => {
  //>> Composición de URL
  const resource =
    RESOURCES.products + "/" + product_id + "/" + RESOURCES.ingredients;
  const url = API_ENDPOINT + resource;

  //>> Respuesta
  type Response = FetchResponseType<ProductIngredientsResponse>;
  let DefaultResponse: ProductIngredientsResponse;

  const result: Response = await fetch(url, {
    method: METHODS.GET,
    headers: packedHeaders(),
  })
    .then((res) => res.json())
    .then((res: Response) => {
      if (res.result_code != RESPONSE_CODES.SUCCESS) {
        throw new Error("No se ha podido conectar con el servidor");
      }
      return res;
    })
    .catch((error) => {
      console.error(error);
      return { result_code: 400, response: DefaultResponse };
    });

  return result;
};

export const UpdateProductIngredients = async (
  product_id: string,
  ingredient_data: any
) => {
  //>> Composición de URL
  const resource =
    RESOURCES.products + "/" + product_id + "/" + RESOURCES.ingredients;
  const url = API_ENDPOINT + resource;

  //>> Respuesta
  type Response = FetchResponseType<null>;
  let DefaultResponse: null;

  const result: Response = await fetch(url, {
    method: METHODS.POST,
    headers: packedHeaders(),
    body: JSON.stringify({ ingredients: ingredient_data }),
  })
    .then((res) => res.json())
    .then((res: Response) => {
      if (res.result_code != RESPONSE_CODES.SUCCESS) {
        throw new Error("No se ha podido conectar con el servidor");
      }
      return res;
    })
    .catch((error) => {
      console.error(error);
      return { result_code: 400, response: DefaultResponse };
    });

  return result;
};
